import {Component, Input, OnInit} from '@angular/core';
import {LgCalculationLogicTypeObjectBaseComponent} from "../lg-calculation-logic-type-object-base.component";
import {CalculationLogicTypeDto} from "../../../../../model/dto/entity/calculation-logic-type.dto";

// EMPTY
@Component({
    selector: 'mvs-lg-calculation-logic-type-object-side',
    templateUrl: 'lg-calculation-logic-type-object-side.component.html',
    standalone: false
})
export class LgCalculationLogicTypeObjectSideComponent extends LgCalculationLogicTypeObjectBaseComponent implements OnInit {

    @Input() dto: CalculationLogicTypeDto;
}